import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  "class": "page-wrapper h-full"
};
var _hoisted_2 = {
  key: 0,
  "class": "layout-container"
};
var _hoisted_3 = {
  "class": "container flex flex-col flex-1"
};
var _hoisted_4 = {
  key: 0,
  "class": "pending-account flex justify-center items-center text-center h-full"
};
var _hoisted_5 = {
  key: 1,
  "class": "fixed z-[300000000] inset-0 flex items-center justify-center overflow-hidden bg-secondary"
};
import Footer from "@/layouts/main-layout/Footer.vue";
import Header from "@/layouts/main-layout/Header.vue";
import * as intercom from '@/lib/intercom';
import { startInterval } from "@/utils/helpers";

import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { ref, onMounted, onBeforeUnmount } from 'vue';
export default {
  __name: 'MainLayout',
  setup: function setup(__props) {
    var store = useStore();
    var route = useRoute();
    var isLoaded = ref(false);
    var updater = null;
    function onInternetConnectionReestablished() {
      console.log("online");
      store.dispatch("loadDerivativesCollateral");
      store.dispatch("loadSpotBalance");
      store.dispatch("newPortfolio/fetchPortfolioTotalAssets");
      store.dispatch("newPortfolio/fetchAssetsInTransfer");
      store.dispatch("fetchDerivatives");
    }
    function fetchData() {
      return _fetchData.apply(this, arguments);
    }
    function _fetchData() {
      _fetchData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var activePortfolioId;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return Promise.all([store.dispatch("portfolio/fetchPortfolios"), store.dispatch("auth/fetchIntercomJwtToken")]);
            case 2:
              activePortfolioId = store.state.portfolio.activePortfolioId;
              if (!activePortfolioId) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return", Promise.all([store.dispatch("fetchDerivatives"), store.dispatch("loadBalanceHistory"), store.dispatch("loadPNLHistoryRealised"), store.dispatch("loadPNLHistoryUnrealised"), store.dispatch("loadPNLHistoryRealised24h"), store.dispatch("loadDerivativesCollateral"), store.dispatch("loadSpotBalance"), store.dispatch("portfolio/fetchLinkedAccount"), store.dispatch("newPortfolio/fetchPortfolioTotalAssets"), store.dispatch("newPortfolio/fetchAssetsInTransfer"), store.dispatch('apiKeys/fetchGateUnifiedAccounts')]));
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _fetchData.apply(this, arguments);
    }
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var activePortfolioId;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            window.addEventListener("online", onInternetConnectionReestablished);
            _context.prev = 1;
            isLoaded.value = false;
            _context.next = 5;
            return fetchData();
          case 5:
            activePortfolioId = store.state.portfolio.activePortfolioId;
            if (activePortfolioId) {
              updater = startInterval(function () {
                store.dispatch("newPortfolio/fetchPortfolioTotalAssets");
                store.dispatch("newPortfolio/fetchAssetsInTransfer");
              }, 60000);
            }
          case 7:
            _context.prev = 7;
            isLoaded.value = true;
            return _context.finish(7);
          case 10:
            intercom.boot({
              user: store.state.auth.user
            });
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1,, 7, 10]]);
    })));
    onBeforeUnmount(function () {
      window.removeEventListener("online", onInternetConnectionReestablished);
      if (updater) {
        updater();
      }
    });
    return function (_ctx, _cache) {
      var _component_PBStatus = _resolveComponent("PBStatus");
      var _component_RouterView = _resolveComponent("RouterView");
      var _component_PBLoader = _resolveComponent("PBLoader");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(isLoaded) ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(Header), _createElementVNode("div", _hoisted_3, [_unref(store).state.portfolio.portfolios.length === 0 && _unref(route).name !== 'security' && _unref(route).name !== 'apikeys' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_PBStatus, {
        note: "",
        message: "Dear customer!",
        empty: "",
        width: "500px"
      }, {
        "default": _withCtx(function () {
          return _toConsumableArray(_cache[0] || (_cache[0] = [_createTextVNode(" We are pleased to welcome you to Bequant Prime! ", -1), _createElementVNode("div", {
            "class": "mb-md"
          }, null, -1), _createTextVNode(" As a next step, please make sure you fill the ", -1), _createElementVNode("a", {
            href: "https://docs.google.com/forms/d/e/1FAIpQLSdT_3-ZQ4Z50Gru31o0Z-qUJT7jrv0_lfZoWQ4Cay1zO0HVrg/viewform",
            "class": "text-primary"
          }, "questionnaire", -1), _createTextVNode(" form. This will significantly speed up the setup of your account. ", -1), _createElementVNode("div", {
            "class": "mb-md"
          }, null, -1), _createTextVNode(" Meanwhile, your Sales Representative will be in touch to discuss your trading needs in depth. After the discussion, a separate chat with a dedicated Support team will be created to guide you through the whole process. ", -1), _createElementVNode("div", {
            "class": "mb-md"
          }, null, -1), _createTextVNode(" If you have any questions about your account, please contact ", -1), _createElementVNode("a", {
            href: "https://bequant.pro/support"
          }, "Bequant support", -1)]));
        }),
        _: 1
      })])) : (_openBlock(), _createBlock(_component_RouterView, {
        key: 1
      }))]), _createVNode(Footer)])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_PBLoader)]))]);
    };
  }
};